
export const DEFAULT_PAGESIZE:number = Number(`${process.env.REACT_APP_DEFAULT_PAGESIZE}`);